<template>
  <div class="ui-gender-select">
    <div
      v-for="gender of genders"
      :key="gender.value"
      :class="[
        'ui-gender-select-item',
        { 'ui-gender-select-item_active': modelValue === gender.value },
      ]"
      @click="$emit('update:modelValue', gender.value)">
      <MiIcon class="ui-gender-select-item__icon" :icon="gender.icon" />
      <div class="ui-gender-select-item__label">{{ gender.label }}</div>
    </div>
  </div>
</template>

<script>
import { User } from '@/models/User.model';
import { MiIcon } from '~shared/ui';

export default {
  name: 'UiGenderSelect',
  components: { MiIcon },
  props: {
    modelValue: String,
  },
  computed: {
    genders() {
      return Object.keys(User.enum.genders).map((key) => ({
        label: this.$t(`User.Genders.${User.enum.genders[key]}`),
        value: User.enum.genders[key],
        icon: this.iconsByGender[User.enum.genders[key]],
      }));
    },

    iconsByGender() {
      return {
        [User.enum.genders.MAN]: 'MALE',
        [User.enum.genders.Woman]: 'FEMALE',
      };
    },
  },
};
</script>

<style lang="scss" src="./index.scss" />
<i18n src="@/locales/user.locales.json" />
